import { render, staticRenderFns } from "./ArtistDashboard.vue?vue&type=template&id=7bb29837"
import script from "./ArtistDashboard.vue?vue&type=script&lang=js"
export * from "./ArtistDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports